/*
 * File: 基础设置-组织架构-组织架构-新建/编辑部门
 */
<template>
    <el-dialog
        :visible="visible"
        :title="formData.dialogTitle"
        width="600px"
        custom-class="organization-department-dialog"
        destroy-on-close
        append-to-body
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        @close="handleClose"
    >
        <PublicForm
            ref="publicFormRef"
            label-width="80px"
            :row="formData"
            :config="config.department.formList"
            :col="config.department.col"
            @data-changed="handleChange"
        />
        <span slot="footer">
            <el-button size="small" @click="handleClose">取消</el-button>
            <el-button type="primary" size="small" @click="handleSave" :loading="isLoading">保存</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { ref, reactive } from '@vue/composition-api';
import { Message } from 'element-ui';
import PublicForm from '@/modules/mdm/components/form/Index.vue';
import { config as configStatic } from '../config';
import { addOrganization, updateOrganization } from '@mdm/api/basicSettings/organization.js';

export default {
    components: { PublicForm },
    props: {},
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const emit = setupContext.emit;
        const config = reactive(configStatic);
        const visible = ref(false);
        const formData = ref({});
        const isLoading = ref(false);

        const show = (data) => {
            visible.value = true;
            formData.value = { ...data, dialogTitle: data.type === 'add' ? '新建部门信息' : '编辑部门信息' };
            config.department.formList.find((v) => v.prop === 'orgCode').disabled = data.type === 'edit';
            const field = config.department.formList.find((v) => v.prop === 'parentName');
            const isRoot = data.type === 'edit' && data.level === 1;
            field.disabled = isRoot;
            field.type = isRoot ? 'input' : 'cascader';
        };
        const handleClose = () => {
            visible.value = false;
            formData.value = {};
        };
        const handleChange = ({ itemSetting }) => {
            if (itemSetting.prop === 'parentName') {
                setupContext.refs.publicFormRef.form.fullName = itemSetting.nodes[0]?.pathLabels?.join('_');
                if (formData.value.type === 'add') {
                    formData.value.parentCode = itemSetting.nodes[0]?.value;
                } else {
                    formData.value.newParentCode = itemSetting.nodes[0]?.value;
                }
            }
        };
        // 保存
        const handleSave = () => {
            setupContext.refs.publicFormRef.validateForm().then(() => {
                const newData = setupContext.refs.publicFormRef.form;
                const api = newData.type === 'add' ? addOrganization : updateOrganization;
                const params = {
                    orgCode: newData.orgCode,
                    deptName: newData.deptName,
                    parentCode: formData.value.parentCode,
                    newParentCode: formData.value.newParentCode || undefined
                };
                isLoading.value = true;
                api(params).then((res) => {
                    isLoading.value = false;
                    if (res && +res.code === 0) {
                        Message.success('保存成功');
                        emit('confirm');
                        handleClose();
                    }
                });
            });
        };
        return {
            config,
            visible,
            formData,
            isLoading,
            show,
            handleClose,
            handleChange,
            handleSave
        };
    }
};
</script>

<style lang="less" >
.organization-department-dialog {
    .el-dialog__body {
        padding: 20px 20px 0px 10px;
    }
}
</style>
